import { isObject, isArray } from '@/utils';

/**
 * 數組轉 字符串
 * @param {value} 轉換的數組
 * @param {nameKey} 顯示的key值
 * 例子： [{id: 'xxx', name: 'name1'},{id: 'xxx2', name: 'name2'] => name1,name2
 */
const arrayToString = (value, nameKey = 'name') => {
  if (typeof value === 'string' || typeof value === 'number') return value;
  if (!isArray(value) || !value.length) return '';
  return value
    .map((val) => {
      return isObject(val) ? val[nameKey] || '' : val;
    })
    .join(',');
};

export default arrayToString;
